var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",attrs:{"width":_vm.width,"src":require(("@/assets/img/icon/" + (_vm.imgName.toLowerCase()) + "-logo.png")),"alt":_vm.imgName,"title":_vm.imgName}})}
var staticRenderFns = []

export { render, staticRenderFns }